import React, { useState, useEffect, useRef } from 'react'

import ScrollAnimation from 'react-animate-on-scroll';

import Banner_1 from '../../static/dale.svg';
import Banner_2 from '../../static/banner_2.svg';
import Banner_3 from '../../static/banner_3.svg';

export default function Dale() {
  
  return ( 
    <section id="dale" className="dale">
      
      <div className="column-left">
        <ScrollAnimation animateIn='bounceInLeft' animateOnce={true} >  
          <h2>
            Un Pulso para  <br/>
            el cambio social
          </h2>
          <div className="desc">
          Las personas son la esencia de nuestro Pulso. Detras de cada causa hay pulsos, detras de ese Pulso podes estár vos.
          </div>
        </ScrollAnimation>
      </div>
      <div className="column-right">
        <ScrollAnimation animateIn='bounceInUp' animateOnce={true} >
          <img src={Banner_1} alt=""/>
        </ScrollAnimation>
      </div>
      

    </section>
  )
}